import { render, staticRenderFns } from "./VideoCallIcon.vue?vue&type=template&id=625ca0d0&scoped=true&"
import script from "./VideoCallIcon.vue?vue&type=script&lang=js&"
export * from "./VideoCallIcon.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallIcon.vue?vue&type=style&index=0&id=625ca0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ca0d0",
  null
  
)

export default component.exports